export const BUNDLE_ITEM_IDS_FIELD_NAME = 'bundleItemIds';
export const DISPUTES_INFO_FIELD_PREFIX = 'disputesInfo';
export const FORM_NAME = 'disputeForm';
